import { cn } from '#app/utils/misc.tsx'

export function Divider({
	className,
	...props
}: { soft?: boolean } & React.ComponentPropsWithoutRef<'hr'>) {
	return (
		<hr
			role="presentation"
			{...props}
			className={cn(className, 'bg-border-secondary h-px w-full border-none')}
		/>
	)
}
